import React from "react";

import { PathMatch, useMatch } from "react-router";

const Match: React.FC<{
  path: string;
  children: (match: PathMatch<string> | null) => React.ReactElement;
}> = props => {
  const match = useMatch(props.path);
  return props.children(match);
};

export default Match;
